export default {
  paged: {
    select: 'id,name,pattern',
    searchSelect: ['name', 'pattern'],
    orderBy: 'name',
    expand: {
      process: { select: 'name' },
    },
  },
  item: {
    select: 'id,name,pattern',
  },
  itemDetail: {
    select: 'id,name,pattern,created,updated',
    expand: {
      process: { select: 'name' },
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
